<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">{{source | titlecase}} Approvals</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                     <ppl-invoice-filter [pageId]="pageId" [filterFields]="fields" (searchEvent)="onSearch($event)">
                    </ppl-invoice-filter>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Approve</strong> and <strong>Reject</strong> actions, please select the
                                applicable invoice.</li>
                            <li>The <strong>Approve All</strong> and <strong>Reject All</strong> actions will update all
                                purchase request that match the search criteria OR all the selected invoice.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched && !listReloading) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true" [enableActions]="true" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="!isReadOnly" [timesheetFor]="'pendedTimesheet'"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)"
                        (gridAction)="onAction($event)"
                        (onPageLoad)="onPageLoad($event)" (rowCellClicked)="onCellClicked($event)"
                        (rowDetailEventTs)="onRowActions($event)"
                        [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else if(!listReloading) {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
    }
</ng-container>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [showButtons]="false" [showOkButton]="false"
    [showClose]="true" [size]="'medium'" [position]="'center'">
    <div class="p-10">
        <form nz-form nz-row [formGroup]="approvalTimesheetForm" class="ppl-p0 mt-2">
            <table class="approval-dialog-table">
                <thead>
                    <tr>
                        <th style="background-color: #a8e4e14d;">{{this.commentText}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input formControlName="comments" nz-input id="comments"
                                placeholder="Enter comments"
                                [nzStatus]="approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched ? 'error' : ''" />
                            @if(approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched) {
                                <div class="error-message">Please add the reject comments.</div>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="this.isDialogNoteDisplayed" class="alert alert-warning">
                <strong>{{this.dialogNoteMessage}}</strong>
            </div>
            <div class="custom-row w-100 save-row">
                <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px;'" label={{dialogButtonLabel}}
                    icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            </div>
        </form>
    </div>
</ppl-popup-dialog>

<!-- Authorization Details Dialog -->
<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'invoice'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

<!-- View Invoice Dialog -->
<div class="filter-panel">
    <ng-template #viewInvoiceDialog let-cancel="cancel">
        <ppl-add-invoice [mode]="mode" [invoiceId]="invoiceId" [providerId]="selectedLineItem?.providerId"
            [consumerId]="selectedLineItem?.consumerId" (invoiceSaved)="handleViewCancel($event)"
            (cancel)="handleViewCancel($event)" [staffView]="true" [isReadOnly]="true"></ppl-add-invoice>
    </ng-template>
</div>

<!-- Paystub PDF Dialog -->
<div class="filter-panel">
    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>

